import { createRouter, createWebHistory } from "vue-router";

import parseRouteParam from "@/utils/parseRouteParam";

export enum Page {
  ConfigurePage = "ConfigurePage",
  RedirectPage = "RedirectPage",
  NotFoundPage = "NotFoundPage",
}

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      redirect: { name: Page.NotFoundPage },
    },
    {
      path: "/configure/:configurationId",
      name: Page.ConfigurePage,
      component: () => import("@/components/pages/ConfigurePage.vue"),
    },
    {
      path: "/:pathMatch(.*)*",
      name: Page.NotFoundPage,
      component: () => import("@/components/pages/NotFoundPage.vue"),
    },
    {
      path: "/v2/configure/:configurationId",
      name: Page.RedirectPage,
      // Redirect old lingering v2 urls
      redirect: (to) => {
        const configurationId = parseRouteParam(to, "configurationId");

        if (!configurationId) {
          return "/not-found";
        }

        return `/configure/${configurationId}`;
      },
    },
  ],
});

export default router;
